module.exports = __webpack_public_path__ + "devicon.681fa39a79c22f0035a0.eot";


//////////////////
// WEBPACK FOOTER
// /home/munkhuu/Desktop/mum/CS572/resume/src/assets/devicons/fonts/devicon.eot
// module id = ../../../../../src/assets/devicons/fonts/devicon.eot
// module chunks = styles